module.exports = "/virtual-football-league/img/amblems/left/logos/ManchesterCity.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/logos/ManchesterCity.png
// module id = 2111
// module chunks = 4